import React, { useEffect, useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import { organizerListOrdersApi, organizerOrdersIncomeApi } from "../../api/api";

import { handleError } from "../../helpers/handleError";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import "../dashboard.css";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [income, setIncome] = useState([]);
  const [loading, setLoading] = useState(false);

  const totals = useMemo(() => {
    const t = { totalIncome: 0, totalDiscount: 0, totalTickets: 0 };
    (income || []).forEach((e) => {
      t.totalIncome += e.income || 0;
      t.totalDiscount += e.discount || 0;
      t.totalTickets += e.totalbooking || 0; // alternative: sum quantities from orders
    });
    return t;
  }, [income]);

  const currencyFormatter = useMemo(
    () =>
      new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    []
  );
  const numberFormatter = useMemo(() => new Intl.NumberFormat("es-AR"), []);

  const formatCurrency = (value) => currencyFormatter.format(Number(value || 0));
  const formatNumber = (value) => numberFormatter.format(Number(value || 0));

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const [o, i] = await Promise.all([organizerListOrdersApi(), organizerOrdersIncomeApi()]);
        setOrders(Array.isArray(o?.data?.info) ? o.data.info : []);
        setIncome(Array.isArray(i?.data?.info) ? i.data.info : []);
      } catch (e) {
        handleError(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  if (loading) return <SpinLoading />;
  return (
    <div className="organizer-page">
      <section className="organizer-section">
      <div className="organizer-section__header">
        <div>
          <p className="organizer-eyebrow">Comercial</p>
          <h2>Pedidos</h2>
          <p className="organizer-section__subtitle">Monitorea tus ingresos, descuentos y reservas confirmadas.</p>
        </div>
      </div>
      <div className="organizer-metrics">
        <div className="organizer-metric-card">
          <span className="label">Ingresos</span>
          <span className="value">{formatCurrency(totals.totalIncome)}</span>
        </div>
        <div className="organizer-metric-card">
          <span className="label">Descuento</span>
          <span className="value">{formatCurrency(totals.totalDiscount)}</span>
        </div>
        <div className="organizer-metric-card">
          <span className="label">Entradas reservadas</span>
          <span className="value">{formatNumber(totals.totalTickets)}</span>
        </div>
      </div>

      <div className="organizer-card">
        <div className="organizer-card__header">
          <div>
            <h3 className="organizer-card__title">Detalle de pedidos</h3>
            <p className="organizer-card__subtitle">Actualizado {new Date().toLocaleDateString()}</p>
          </div>
          <div className="organizer-chip organizer-chip--secondary">
            {formatNumber(orders.length)} pedidos
          </div>
        </div>
        <div className="organizer-table">
          <Table responsive className="organizer-table__inner align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Evento</th>
                <th>Nombre</th>
              <th>Correo</th>
              <th>Cant.</th>
              <th>Pagado</th>
              <th>Descuento</th>
              <th>Pago</th>
              <th>Estado</th>
              <th>Creado</th>
            </tr>
          </thead>
          <tbody>
            {(orders || []).map((o) => (
              <tr key={o._id}>
                <td>{o.orderid || '-'}</td>
                <td>{o.eventid?.name || '-'}</td>
                <td>{o.name || '-'}</td>
                <td>{o.email || '-'}</td>
                <td>{o.quantity}</td>
                <td>{formatCurrency(o.paidamount)}</td>
                <td>{formatCurrency(o.discount)}</td>
                <td>{o.paymentstatus}</td>
                <td>{o.status}</td>
                <td>{o.createdAt ? new Date(o.createdAt).toLocaleString() : '-'}</td>
              </tr>
            ))}
            {orders.length === 0 && (<tr><td colSpan={10} className="text-center text-muted py-3">Sin pedidos</td></tr>)}
          </tbody>
        </Table>
        </div>
      </div>
      </section>
    </div>
  );
};

export default Orders;
